//
//
//
//
//
//

  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState({
        lotteryBuySwitch: state => state.linkList.lotteryBuySwitch
      })
    },
    watch: {
      lotteryBuySwitch(v) {
        if (v === '0') this.$router.replace({ path: '/home' })
      }
    },
    created() {
      if (this.lotteryBuySwitch === '0') this.$router.replace({ path: '/home' })
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/betting/index.vue